var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifEnjoy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.32545 10.3163V9.05263C3.32545 5.89713 5.89712 3.32545 9.05263 3.32545H25V0H9.05263C4.05705 0 0 4.06444 0 9.05263V22.2953C0 23.2117 0.74634 23.958 1.66273 23.958H25V20.6326H3.32545V13.6417H14.159V10.3163H3.32545Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifEnjoy);
export default __webpack_public_path__ + "static/media/lif-enjoy.538a53451a7dc8b56934d297d0b58888.svg";
export { ForwardRef as ReactComponent };